<template>
<span data-promotion>
    <div :id="showPromotion" v-if="showPromotion && showPromotion" style="background:#fff">
        <div class="detail-item" @click.deb="bindShowDetail()" style="border-top:0.05rem solid #eee">
            <a href="javascript:;">
                <div class="item-name" data-name="促销">Promotion:</div>
                <div class="item-con est">
                    <dl>
                        <dd class="promotion" v-if="groupsInfo"><span>拼团</span>拼团商品，点击进入活动页面参与</dd>
                        <dd class="promotion" v-if="giftList.length" data-name="赠品"><span>GIFT</span></dd>
                        <dd class="promotion" v-if="conform && conform.length" data-name="满优惠"><span>DISCOUNT</span></dd>
                    </dl>
                </div>
              <div class="item-more-right" style=""></div>
              <!--<div class="item-more" style="display: block"></div>-->
            </a>
        </div>
    </div>
    <transition name="ncbottom">
        <div class="nctouch-bottom-mask mask-show" v-show="show" ref="layer">
            <!--<div class="nctouch-bottom-mask-bg" @click="bindHide()" @touchmove="excludeTouch"></div>-->
            <div class="nctouch-bottom-mask-block">
                <div class="nctouch-bottom-mask-top" @touchmove="excludeTouch">
                    <div class="close"><i class="closed" @click="bindHide()" data-name="促销"></i>Promotion</div>
                </div>
                <div class="goods-options">
                    <div class="options-content" ref="scroll">
                        <ul>
                            <li class="options-item" v-if="groupsInfo" @click="bindGoGroup()">
                                <div class="item-name"><span data-name="拼团">拼团</span></div>
                                <div class="item-content">
                                    <dl>
                                        <dd class="explain">
                                            <span class="explain-text">拼团商品，点击进入活动页面参与</span>
                                            <span class="item-more"></span>
                                        </dd>
                                    </dl>
                                </div>
                            </li>
                            <li class="options-item" v-if="giftList.length">
                                <div class="item-name"><span data-name="赠品">GIFT</span></div>
                                <div class="item-content">
                                    <dl>
                                        <dd class="explain" v-for="gItem in giftList"
                                            @click="bindGoGoodsDetail(gItem.commonId , gItem.goodsId)">
                                            <span class="gifts-name">{{gItem.goodsName}}&nbsp;{{gItem.goodsFullSpecs}}</span>
                                            <span class="gifts-number">x{{gItem.giftNum}}</span>
                                            <span class="item-more"></span>
                                        </dd>
                                    </dl>
                                </div>
                            </li>
                            <li class="options-item" v-if="conform && conform.length">
                                <div class="item-name"><span data-name="满优惠">DISCOUNT</span></div>
                                <div class="item-content">
                                    <dl>
                                        <dd class="explain" v-for="cItem in conform">{{cItem.contentCartRule}}</dd>
                                    </dl>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
        </div>
    </div>
    </transition>
</span>
</template>

<script>
    // 商品促销
    var iScrollInstance;
    export default {
        props: {
            //拼团信息
            groups: {

                required: false
            },
            //标识是否是拼团商品
            isGroup:{
                type: Number,
                required: false
            } ,
            //sku赠品信息
            gift: {
                type: Array,
                required: false
            },
            //满优惠信息
            conform: {
                type: Array,
                required: false
            },
            //当前skuid
            currentSku: {
                type: Number,
                required: true
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                show: false
            }
        },
        /**
         * 计算属性
         */
        computed: {
            //拼团信息
            groupsInfo : function () {
                if(Nc.isNumber(this.isGroup) && !Nc.isEmpty(this.groups)){
                    return this.isGroup ? this.groups : null
                }else{
                    return null
                }
            },


            //是否显示整个活动区域
            showPromotion: function () {
                return !!( this.groupsInfo || this.giftList.length || this.conform.length )
            },
            //赠品
            giftList() {
                if (!this.gift || !this.gift.length) return [];
                var _goodsId = this.currentSku;
                return this.gift.filter(function (value) {
                    return value.itemId == _goodsId && value.giftType == 2;
                })
            },
            //赠品显示文字
            giftText() {
                if (!this.giftList.length) return null;
                return this.giftList.map(function (value) {
                    return value.goodsName + " " + ( value.goodsFullSpecs ?value.goodsFullSpecs : '')  + " x " + value.giftNum
                }).join("，")

            },
            //满优惠剪短文字
            conformText() {
                if (!this.conform || !this.conform.length) return null
                return this.conform.map(function (item) {
                    return item.contentCartRule
                }).join("，")
            }
        },



        mounted() {

            var $layer = this.$refs.layer;
            var $body = document.getElementsByTagName("body")[0];
            $body.appendChild($layer);
        },



        updated() {
            this.$nextTick(function () {
                if (iScrollInstance) return;
                iScrollInstance = new IScroll(this.$refs.scroll, {
                    scrollX: false,
                    scrollY: true,
                    click: true
                });
            })

        },

        /**
         * 自定义方法
         */
        methods: {
            //去除无关的touch事件
            excludeTouch: function (event) {

                event.preventDefault();
                return false;
            },
            //关闭
            bindHide() {
                this.show = false;
            },
            //弹出详细的活动
            bindShowDetail : function () {
              ga('send', 'event', '选择查看促销按钮', '点击', '按钮点击'); //谷歌锚点
              this.show = true;
            },
            //点击跳到商品详情
            bindGoGoodsDetail(commonId, goodsId) {

                this.$emit('gogoodsdetail', commonId, goodsId)
            },
            //跳转到开团列表
            bindGoGroup(){
//                console.log("goods-promotion->creategroup")
                this.$emit('gocreategroup')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/goods-promotion/goods-promotion.vue